import React from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import GamesTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useIntl } from 'umi';
import {
  GuideCompanyDelay as CompanyUserGuide,
  COMPANY_GUIDE_CLASSNAMES,
} from '@intelligence/components/UserGuide/Company';
import useGamesShareCardAutoScrollIntoViewEffect from '@intelligence/pages/TopCharts/Companies/components/GamesDetails/hooks/useGamesShareCardAutoScrollIntoViewEffect';

const EditionsShareCard = (props: any) => {
  const {
    headerFixed,
    chartType,
    setChartType,
    entityType,
    tableData = [],
    lineData,
    cardStatus,
    tableTotal,
    dateType,
    startDate,
    endDate,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    tabId,
    setChartLoading,
    chartLoading,
    gameName,
    barOrPieList,
    titleNow,
    dataSource,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [chartType, setChartType] = useState('bar');

  useGamesShareCardAutoScrollIntoViewEffect(isLoading);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_games_share` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={
          <span className={COMPANY_GUIDE_CLASSNAMES.ELEMENT4}>
            {formatMessage({ id: `dbi_detail_games_share` })}
          </span>
        }
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={tabId}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-game'}
            titleNow={titleNow}
            tableData={barOrPieList} // 不要用tableData, 排序和分页表格数据会变
            gameName={gameName}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <GamesTable
          tabId={tabId}
          tableLoading={tableLoading}
          tableTotal={tableTotal}
          tableData={tableData}
          dateType={dateType}
          dataSource={dataSource}
          columnsList={columnsList}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          entityType={entityType}
        />
      </CardSlotV2>
      {headerFixed && !isLoading && !isNoData && !isError && <CompanyUserGuide />}
    </div>
  );
};

export default EditionsShareCard;
